<template>
  <v-lazy>
    <apexchart type="line" height="200" :options="chartOptions" :series="series"></apexchart>
  </v-lazy>
</template>

<script>
export default {
  data() {
    return {
      series: [
        {
          name: "Contas individuais",
          data: this.individualAccountsData
        },
        {
          name: "Contas agregadas",
          data: this.aggregateAccountsData
        }
      ],
      chartOptions: {
        chart: {
          type: "line",
          toolbar: {
            show: false
          },
          fontFamily: "Montserrat, sans-serif"
        },
        colors: ["#0012A6", "#B7000C"],
        dataLabels: {
          enabled: false
        },
        legend: {
          show: true,
          showForSingleSeries: false,
          showForNullSeries: true,
          showForZeroSeries: true,
          position: "right",
          horizontalAlign: "right",
          floating: false,
          fontSize: "12px",
          fontFamily: "Montserrat, sans-serif",
          fontWeight: 400,
          formatter: undefined,
          inverseOrder: false,
          width: undefined,
          height: undefined,
          tooltipHoverFormatter: undefined,
          offsetX: -20,
          offsetY: 0,
          labels: {
            colors: ["#B7000C", "#0012A6"],
            useSeriesColors: true
          },
          markers: {
            width: 12,
            height: 12,
            strokeWidth: 0,
            strokeColor: undefined,
            fillColors: undefined,
            radius: 12,
            customHTML: undefined,
            onClick: undefined,
            offsetX: 0,
            offsetY: 0
          },
          itemMargin: {
            horizontal: 0,
            vertical: 0
          },
          onItemClick: {
            toggleDataSeries: false
          },
          onItemHover: {
            highlightDataSeries: true
          }
        },
        stroke: {
          curve: "straight",
          width: 1
        },
        xaxis: {
          categories: this.categories,
          labels: {
            style: {
              fontSize: "12px"
            }
          }
        },
        yaxis: {
          showAlways: true,
          min: 0,
          tickAmount: 3
        },
        fill: {
          opacity: 1
        }
      },
      tooltip: {
        x: [
          {
            formatter: function(y) {
              return y.toFixed();
            }
          },
          {
            formatter: function(y) {
              return y.toFixed();
            }
          }
        ],
        y: [
          {
            formatter: function(y) {
              return y.toFixed();
            }
          },
          {
            formatter: function(y) {
              return y.toFixed();
            }
          }
        ],
        z: [
          {
            formatter: function(y) {
              return y.toFixed();
            }
          },
          {
            formatter: function(y) {
              return y.toFixed();
            }
          }
        ]
      }
    };
  },
  props: {
    individualAccountsData: {
      type: Array,
      required: true
    },
    aggregateAccountsData: {
      type: Array,
      required: true
    },
    categories: {
      type: Array,
      required: true
    }
  }
};
</script>